import { useParams } from 'react-router-dom';
import { UserProfile } from '@/components/composed';

/**
 * User Profile Page
 *
 * URL Pattern Support (Task T058 - 038-url-pattern-refactor):
 * - /u/<username-slug> → Display user profile
 *
 * Note: Global ID to username-slug URL updates (T059) deferred until useUser hook is available.
 * The UserProfile component should handle user fetching and display.
 */
export function UserProfilePage() {
  const { username } = useParams<{ username: string }>();

  if (!username) {
    return null;
  }

  return <UserProfile username={username} />;
}
